import { Deserializable } from '../protocols/deserializable';

export class MpSpousalContributionYearToDate implements Deserializable {
  public spouseId!: number;
  public spouseName!: string;
  public contributedAmount!: number;
  public paidOutAmount!: number;
  public yearToDateAmount!: number;

  public onDeserialize(): void {}
}
